import MarketsRealtime from "./MarketsRealtime";

export default function MarketsTab() {
  return <MarketsRealtime />;
}